module.exports = __webpack_public_path__ + "extend-booking-image.2fb138cc583365acb343.svg";


//////////////////
// WEBPACK FOOTER
// C:/unnati/latestWebCode29march/src/assets/images/extend-booking-image.svg
// module id = ../../../../../src/assets/images/extend-booking-image.svg
// module chunks = main